import z from "zod";

import { type ErrorDetails, RemiHttpCode } from "./remi-app";

// TODO: Add actual error types for external service
const webhookProcessorErrorTypeValues = [
  "KNOCK_MESSAGE_FAILURE",
  "TWILIO_SMS_FAILED",
  "MATERIALS_SYNC_INVALID_PROJECT",
  "INVALID_EVENT_TYPE",
  "CONVERSATION_ITEM_NOT_FOUND",
  "HOVER_WEBHOOK_VERIFICATION_FAILED",
  "WEBHOOK_RETRIES_EXHAUSTED",
] as const;

const webhookProcessorErrorTypeSchema = z.enum(webhookProcessorErrorTypeValues);
const WebhookProcessorErrorType = webhookProcessorErrorTypeSchema.enum;
type WebhookProcessorErrorType = z.infer<typeof webhookProcessorErrorTypeSchema>;

export type WebhookProcessorErrors =
  | {
      errorType: typeof WebhookProcessorErrorType.KNOCK_MESSAGE_FAILURE;
      data: {
        eventBody: unknown;
      };
    }
  | {
      errorType: typeof WebhookProcessorErrorType.TWILIO_SMS_FAILED;
      data: {
        eventBody: unknown;
      };
    }
  | {
      errorType: typeof WebhookProcessorErrorType.MATERIALS_SYNC_INVALID_PROJECT;
      data: {
        projectId: number;
        reason: string;
      };
    }
  | {
      errorType: typeof WebhookProcessorErrorType.INVALID_EVENT_TYPE;
      data: {
        event: unknown;
      };
    }
  | {
      errorType: typeof WebhookProcessorErrorType.CONVERSATION_ITEM_NOT_FOUND;
      data: {
        conversationItemId: string;
      };
    }
  | {
      errorType: typeof WebhookProcessorErrorType.HOVER_WEBHOOK_VERIFICATION_FAILED;
      data: undefined;
    }
  | {
      errorType: typeof WebhookProcessorErrorType.WEBHOOK_RETRIES_EXHAUSTED;
      data: {
        webhookId: string;
        webhookType: string;
        route: string;
        receiveCount: number;
      };
    };

export const webhookProcessorErrorDetails: Record<WebhookProcessorErrorType, ErrorDetails> = {
  [WebhookProcessorErrorType.KNOCK_MESSAGE_FAILURE]: {
    sentryDescription: "Knock message failure",
    remiHttpCode: RemiHttpCode.INTERNAL_SERVER_ERROR,
  },
  [WebhookProcessorErrorType.TWILIO_SMS_FAILED]: {
    sentryDescription: "Twilio SMS failed",
    remiHttpCode: RemiHttpCode.INTERNAL_SERVER_ERROR,
  },
  [WebhookProcessorErrorType.MATERIALS_SYNC_INVALID_PROJECT]: {
    sentryDescription: "Materials sync failed - invalid project",
    remiHttpCode: RemiHttpCode.BAD_REQUEST,
  },
  [WebhookProcessorErrorType.INVALID_EVENT_TYPE]: {
    sentryDescription: "Invalid event type",
    remiHttpCode: RemiHttpCode.BAD_REQUEST,
  },
  [WebhookProcessorErrorType.CONVERSATION_ITEM_NOT_FOUND]: {
    sentryDescription: "Conversation item not found",
    remiHttpCode: RemiHttpCode.INTERNAL_SERVER_ERROR,
  },
  [WebhookProcessorErrorType.HOVER_WEBHOOK_VERIFICATION_FAILED]: {
    sentryDescription: "Hover webhook verification PUT returned non-2xx — triggers Hover retry",
    remiHttpCode: RemiHttpCode.INTERNAL_SERVER_ERROR,
  },
  [WebhookProcessorErrorType.WEBHOOK_RETRIES_EXHAUSTED]: {
    sentryDescription: "Webhook dropped after every retry failed with an error that was reported only as a metric",
    remiHttpCode: RemiHttpCode.INTERNAL_SERVER_ERROR,
  },
};
